import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';
var Caract_solicitudComponent = /** @class */ (function () {
    function Caract_solicitudComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            num_reso_perm: new FormControl(''),
            tipo_garantia: new FormControl(''),
            fecha_reso_perm: new FormControl({ value: '', disabled: true })
        });
        if (!JSON.parse(localStorage.getItem("caract_solicitud"))) {
            localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("caract_solicitud"));
            this.form.controls['num_reso_perm'].setValue(this.rows[0] ? this.rows[0].num_reso_perm : '');
            this.form.controls['fecha_reso_perm'].setValue(this.rows[0] ? this.rows[0].fecha_reso_perm : null);
            this.form.controls['tipo_garantia'].setValue(this.rows[0] ? this.rows[0].tipo_garantia : '');
        }
        this.caract_solicitud = { num_reso_perm: '', fecha_reso_perm: null, tipo_garantia: '' };
    }
    Caract_solicitudComponent.prototype.add_caract_solicitud = function (event, type) {
        if (event) {
            this.fecha = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("caract_solicitud"));
            if (temp[0]) {
                this.fecha = temp[0].fecha_reso_perm;
            }
        }
        localStorage.setItem("caract_solicitud", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_solicitud");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            num_reso_perm: this.form.value.num_reso_perm,
            tipo_garantia: this.form.value.tipo_garantia,
            fecha_reso_perm: this.fecha
        });
        localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));
    };
    Caract_solicitudComponent.prototype.delete_caract_solicitud = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_solicitud", JSON.stringify(this.rows));
            }
        }
    };
    return Caract_solicitudComponent;
}());
export { Caract_solicitudComponent };
